export namespace DatabaseEnum {
	export enum family {
		STRING = 1,
		BOOLEAN = 2,
		NUMBER = 3,
		DATE = 4,
		FLOAT = 5
	}

	export enum databaseId {
		GENERIC = -2,
		DATAMASKING = -6,
		NETEZZA = 0,
		TERADATA = 1,
		ORACLE = 2,
		FLATFILE = 3,
		POSTGRE_SQL = 4,
		DB2 = 5,
		HIVE = 6,
		MSSQL = 7,
		BIGINSIGHTS = 8,
		COBOL = 9,
		SALESFORCE = 10,
		EXADATA = 11,
		GREENPLUM = 12,
		HAWQ = 13,
		DFS = 14,
		JSON = 15,
		HBASE = 16,
		XSD = 17,
		SPLICE_MACHINE = 18,
		TWITTER = 19,
		FACEBOOK = 20,
		SPARK = 21,
		JMS = 22,
		KAFKA = 23,
		CASSANDRA = 24,
		SYBASE = 25,
		SAS = 26,
		THOUGHTSPOT = 27,
		SNOWFLAKE = 28,
		MYSQL = 29,
		BIGQUERY = 30,
		REST = 31,
		AVRO = 32,
		PARQUET = 33,
		AMAZONS3 = 34,
		DRUID = 35,
		REDSHIFT = 36,
		GOOGLE_CLOUD_STORAGE = 37,
		AURORA = 38,
		OFFICE365 = 39,
		JSONC = 79, //add by sharmi 04-3-25
		GOOGLE_DOUBLECLICK_SEARCH = 40,
		DENTRIX = 41,
		EAGLESOFT = 42,
		GOOGLE_ANALYTICS = 43,
		GOOGLE_ADWORDS = 44,
		GOOGLE_PUBSUB = 45,
		ICEBERG = 81,
		MARIADB = 46,
		AZURE_BLOB_STORAGE = 47,
		ACTIVE_DIRECTORY = 48,
		MONGODB = 50,
		CONNECTDIRECTMAINFRAME = 49,
		AZURESYNAPSE = 52,
		IOTHUB = 53,
		SAPHANA = 54,
		Phoenix = 56,
		EXCEL = 62,
		RESTAPI = 57,
		JDBC = 51,
		DYNAMODB = 75 ,  //piyush <01-11-2023>
		RAVENDB=76, //Mangesh & Yash (9th April 2024)
		SHAREPOINT = 77, //SHARMI & PIYUSH 30-08-24
     	SMARTSHEET = 80, //RushiM (17-11-2025)

	}

	export enum iothub {
		ID = 53,
		NAME = "IoTHub",
		CODE = "IoTHub",
		EQUIVALENT_TAG = 'IoTid',
		IMAGE_URL = ''
	}
	export enum saphana {
		ID = 54,
		NAME = "SapHana",
		CODE = "SH",
		EQUIVALENT_TAG = 'shid',
		IMAGE_URL = ''
	}
	export enum azuresynapse {
		ID = 52,
		NAME = "AzureSynapseAnalytics",
		CODE = "ASA",
		EQUIVALENT_TAG = 'msid',
		IMAGE_URL = ''
	}

	export enum connectDirectMainframe {
		ID = 49,
		NAME = "ConnectDirect",
		CODE = "CD",
		EQUIVALENT_TAG = 'myid',
		IMAGE_URL = ''
	}

	export enum mongoDb {
		ID = 50,
		NAME = "MongoDB",
		CODE = "MG",
		EQUIVALENT_TAG = 'adid',
		IMAGE_URL = ''
	}

	export enum activedirectory {
		ID = 48,
		NAME = "Active Directory",
		CODE = "AD",
		EQUIVALENT_TAG = 'myid',
		IMAGE_URL = ''
	}

	export enum netezza {
		ID = 0,
		NAME = 'Netezza',
		CODE = 'NZ',
		EQUIVALENT_TAG = 'nzid',
		IMAGE_URL = ''
	}

	export enum teradata {
		ID = 1,
		NAME = 'Teradata',
		CODE = 'TD',
		EQUIVALENT_TAG = 'tdid',
		IMAGE_URL = ''
	}

	export enum oracle {
		ID = 2,
		NAME = 'Oracle',
		CODE = 'OR',
		EQUIVALENT_TAG = 'orid',
		IMAGE_URL = ''
	}

	export enum flatfile {
		ID = 3,
		NAME = 'Flatfile',
		CODE = 'FF',
		EQUIVALENT_TAG = 'ftid',
		IMAGE_URL = ''
	}

	export enum postgresql {
		ID = 4,
		NAME = 'PostgreSQL',
		CODE = 'PG',
		EQUIVALENT_TAG = 'pgid',
		IMAGE_URL = ''
	}

	export enum db2 {
		ID = 5,
		NAME = 'DB2',
		CODE = 'DB',
		EQUIVALENT_TAG = 'dbid',
		IMAGE_URL = ''
	}

	export enum hive {
		ID = 6,
		NAME = 'Hive',
		CODE = 'HV',
		EQUIVALENT_TAG = 'hvid',
		IMAGE_URL = ''
	}

	export enum mssql {
		ID = 7,
		NAME = 'MSSQL',
		CODE = 'MS',
		EQUIVALENT_TAG = 'msid',
		IMAGE_URL = ''
	}

	export enum biginsights {
		ID = 8,
		NAME = 'BigInsights',
		CODE = 'BI',
		EQUIVALENT_TAG = 'bsid',
		IMAGE_URL = ''
	}

	export enum cobol {
		ID = 9,
		NAME = 'Cobol',
		CODE = 'CBLCJ',
		EQUIVALENT_TAG = 'cbid',
		IMAGE_URL = ''
	}

	export enum salesforce {
		ID = 10,
		NAME = 'Salesforce',
		CODE = 'SF',
		EQUIVALENT_TAG = 'sfid',
		IMAGE_URL = ''
	}

	export enum exadata {
		ID = 11,
		NAME = 'Exadata',
		CODE = 'ED',
		EQUIVALENT_TAG = 'exid',
		IMAGE_URL = ''
	}

	export enum greenplum {
		ID = 12,
		NAME = 'Greenplum',
		CODE = 'GP',
		EQUIVALENT_TAG = 'gpid',
		IMAGE_URL = ''
	}

	export enum hawq {
		ID = 13,
		NAME = 'HAWQ',
		CODE = 'HQ',
		EQUIVALENT_TAG = 'hqid',
		IMAGE_URL = ''
	}

	export enum dfs {
		ID = 14,
		NAME = 'DFS',
		CODE = 'HD',
		EQUIVALENT_TAG = 'hdid',
		IMAGE_URL = ''
	}

	export enum json {
		ID = 15,
		NAME = 'JSON',
		CODE = 'JS',
		EQUIVALENT_TAG = 'jsid',
		IMAGE_URL = ''
	}

	export enum hbase {
		ID = 16,
		NAME = 'HBase',
		CODE = 'HB',
		EQUIVALENT_TAG = 'hbid',
		IMAGE_URL = ''
	}

	export enum xsd {
		ID = 17,
		NAME = 'XML',
		CODE = 'XD',
		EQUIVALENT_TAG = 'xdid',
		IMAGE_URL = ''
	}

	export enum splicemachine {
		ID = 18,
		NAME = 'SpliceMachine',
		CODE = 'SP',
		EQUIVALENT_TAG = 'spid',
		IMAGE_URL = ''
	}

	export enum twitter {
		ID = 19,
		NAME = 'Twitter',
		CODE = 'TW',
		EQUIVALENT_TAG = 'twid',
		IMAGE_URL = ''
	}

	export enum facebook {
		ID = 20,
		NAME = 'Facebook',
		CODE = 'FB',
		EQUIVALENT_TAG = 'fbid',
		IMAGE_URL = ''
	}

	export enum spark {
		ID = 21,
		NAME = 'Spark',
		CODE = 'SK',
		EQUIVALENT_TAG = 'skid',
		IMAGE_URL = ''
	}

	export enum jsonc { //add by sharmi on 04-3-25
		ID = 79,
		NAME = 'JsonC',
		CODE = 'JC',
		EQUIVALENT_TAG = 'jcid',
		IMAGE_URL = ''
	}

  export enum smartsheet {  // add by RushiM on 17-11-2025
        ID = 80,
        NAME = 'Smartsheet',
        CODE = 'SM',
        EQUIVALENT_TAG = 'smid',
        IMAGE_URL = ''
    }

	export enum jms {
		ID = 22,
		NAME = 'JMS',
		CODE = 'JM',
		EQUIVALENT_TAG = 'jmid',
		IMAGE_URL = ''
	}

	export enum kafka {
		ID = 23,
		NAME = 'Kafka',
		CODE = 'KK',
		EQUIVALENT_TAG = 'kkid',
		IMAGE_URL = ''
	}

	export enum cassandra {
		ID = 24,
		NAME = 'Cassandra',
		CODE = 'CS',
		EQUIVALENT_TAG = 'csid',
		IMAGE_URL = ''
	}

	export enum sybase {
		ID = 25,
		NAME = 'Sybase',
		CODE = 'SY',
		EQUIVALENT_TAG = 'syid',
		IMAGE_URL = ''
	}

	export enum sas {
		ID = 26,
		NAME = 'SAS',
		CODE = 'SS',
		EQUIVALENT_TAG = 'ssid',
		IMAGE_URL = ''
	}


	export enum thoughtspot {
		ID = 27,
		NAME = 'ThoughtSpot',
		CODE = 'TS',
		EQUIVALENT_TAG = 'tsid',
		IMAGE_URL = ''
	}

	export enum snowflake {
		ID = 28,
		NAME = 'Snowflake',
		CODE = 'SN',
		EQUIVALENT_TAG = 'snid',
		IMAGE_URL = ''
	}

	export enum mysql {
		ID = 29,
		NAME = 'MySQL',
		CODE = 'MY',
		EQUIVALENT_TAG = 'myid',
		IMAGE_URL = ''
	}

	export enum bigquery {
		ID = 30,
		NAME = 'Bigquery',
		CODE = 'BQ',
		EQUIVALENT_TAG = 'bqid',
		IMAGE_URL = ''
	}

	export enum rest {
		ID = 31,
		NAME = 'Webservice',
		CODE = 'RT',
		EQUIVALENT_TAG = 'rtid',
		IMAGE_URL = ''
	}

	export enum avro {
		ID = 32,
		NAME = 'Avro',
		CODE = 'AV',
		EQUIVALENT_TAG = 'avid',
		IMAGE_URL = ''
	}

	export enum parquet {
		ID = 33,
		NAME = 'Parquet',
		CODE = 'PR',
		EQUIVALENT_TAG = 'prid',
		IMAGE_URL = ''
	}

	export enum amazons3 {
		ID = 34,
		NAME = 'AmazonS3',
		CODE = 'AZ',
		EQUIVALENT_TAG = 'azid',
		IMAGE_URL = ''
	}

	export enum druid {
		ID = 35,
		NAME = 'Druid',
		CODE = 'DR',
		EQUIVALENT_TAG = 'drid',
		IMAGE_URL = ''
	}

	export enum redshift {
		ID = 36,
		NAME = 'Redshift',
		CODE = 'RS',
		EQUIVALENT_TAG = 'rsid',
		IMAGE_URL = ''
	}

	export enum google_cloud_storage {
		ID = 37,
		NAME = 'GoogleCloudStorage',
		CODE = 'GC',
		EQUIVALENT_TAG = 'gcid',
		IMAGE_URL = ''
	}

	export enum aurora {
		ID = 38,
		NAME = 'Aurora',
		CODE = 'AU',
		EQUIVALENT_TAG = 'auid',
		IMAGE_URL = ''
	}

	export enum office365 {
		ID = 39,
		NAME = 'Office365',
		CODE = 'OL',
		EQUIVALENT_TAG = 'olid',
		IMAGE_URL = ''
	}

	export enum iceberg {
		ID = 81,
		NAME = 'Iceberg',
		CODE = 'IB',
		EQUIVALENT_TAG = 'ibid',
		IMAGE_URL = ''
	}

	export enum sharepoint {
		ID = 77,
		NAME = 'Sharepoint',
		CODE = 'ST',
		EQUIVALENT_TAG = 'stid',
		IMAGE_URL = ''
	}

	export enum google_doubleclick_search {
		ID = 40,
		NAME = 'Google Doubleclick Search',
		CODE = 'DC',
		EQUIVALENT_TAG = 'dcid',
		IMAGE_URL = ''
	}

	export enum dentrix {
		ID = 41,
		NAME = 'Dentrix',
		CODE = 'DX',
		EQUIVALENT_TAG = 'dxid',
		IMAGE_URL = ''
	}

	export enum eaglesoft {
		ID = 42,
		NAME = 'EagleSoft',
		CODE = 'ES',
		EQUIVALENT_TAG = 'esid',
		IMAGE_URL = ''
	}

	export enum google_analytics {
		ID = 43,
		NAME = 'GoogleAnalytics',
		CODE = 'GA',
		EQUIVALENT_TAG = 'gaid',
		IMAGE_URL = ''
	}

	export enum google_adwords {
		ID = 44,
		NAME = 'GoogleAdwords',
		CODE = 'GW',
		EQUIVALENT_TAG = 'gwid',
		IMAGE_URL = ''
	}

	export enum google_pubsub {
		ID = 45,
		NAME = 'GooglePubSub',
		CODE = 'GS',
		EQUIVALENT_TAG = 'gsid',
		IMAGE_URL = ''
	}

	export enum mariaDB {
		ID = 46,
		NAME = 'MariaDB',
		CODE = 'MD',
		EQUIVALENT_TAG = 'mdid',
		IMAGE_URL = ''
	}

	export enum azure_blob_storage {
		ID = 47,
		NAME = 'BlobStorage',
		CODE = 'BS',
		EQUIVALENT_TAG = 'bsid',
		IMAGE_URL = ''
	}

	export enum generic {
		ID = -2,
		NAME = 'Generic',
		CODE = 'GN',
		EQUIVALENT_TAG = 'gnid',
		IMAGE_URL = ''
	}

	export enum datamasking {
		ID = -6,
		NAME = 'DataMasking',
		CODE = 'DM',
		EQUIVALENT_TAG = 'dmid',
		IMAGE_URL = ''
	}

	export enum Phoenix {

		ID = 56,
		NAME = 'Phoenix',
		CODE = 'PX',
		EQUIVALENT_TAG = 'asid',
		IMAGE_URL = ''
	}
	export enum restAPI {

			ID = 57,
			NAME = "REST_API",
			CODE = "RC",
			EQUIVALENT_TAG = 'rcid',
			IMAGE_URL = ''
		}
	export enum excel {
		ID = 62,
		NAME = 'Excel',
		CODE = 'EL',
		EQUIVALENT_TAG = 'elid',
		IMAGE_URL = ''
	}
	//piyush <01-11-2023>
	export enum dynamoDB {
		ID = 75,
		NAME = 'Dynamodb',
		CODE = 'DN',
		EQUIVALENT_TAG = 'dnid',
		IMAGE_URL = ''
	}

	// Mangesh & yash (9th April 2024)
	export enum ravenDB {
		ID = 76,
		NAME = 'Ravendb',
		CODE = 'RN',
		EQUIVALENT_TAG = 'rnid',
		IMAGE_URL = ''
	}

	//piyush <04-03-24>
	export enum vertica {
		ID = 71,
		NAME = 'vertica',
		CODE = 'VT',
		EQUIVALENT_TAG = 'vtid',
		IMAGE_URL = ''
	}
	export enum datatypes_constants {
		FAMILY_DATATYPE_STRING_ID = 1,
		FAMILY_DATATYPE_BOOL_ID = 2,
		FAMILY_DATATYPE_NUMBER_ID = 3,
		FAMILY_DATATYPE_DATE_ID = 4,
		FAMILY_DATATYPE_FLOAT_ID = 5
	}
}
